{
  "GENERAL_SETTINGS": {
    "LIMIT_MESSAGES": {
      "CONVERSATION": "Vous avez dépassé la limite de conversations. Le plan Hacker n'autorise que 500 conversations.",
      "INBOXES": "Vous avez dépassé la limite de boîtes de réception. Le plan Hacker prend uniquement en charge le chat en direct sur le site Web. Les boîtes de réception supplémentaires comme l'e-mail, WhatsApp, etc. nécessitent un plan payant.",
      "AGENTS": "Vous avez dépassé la limite d'agents. Le plan Hacker n'autorise que 2 agents.",
      "NON_ADMIN": "Veuillez contacter votre administrateur pour mettre à niveau le plan et continuer à utiliser toutes les fonctionnalités."
    },
    "TITLE": "Paramètres du compte",
    "SUBMIT": "Mettre à jour les paramètres",
    "BACK": "Précédent",
    "DISMISS": "Rejeter",
    "UPDATE": {
      "ERROR": "Impossible de mettre à jour les paramètres, essayez à nouveau !",
      "SUCCESS": "Paramètres du compte mis à jour avec succès"
    },
    "ACCOUNT_DELETE_SECTION": {
      "TITLE": "Supprimer votre compte",
      "NOTE": "Une fois que vous supprimez votre compte, toutes vos données seront supprimées.",
      "BUTTON_TEXT": "Supprimer votre compte",
      "CONFIRM": {
        "TITLE": "Supprimer le compte",
        "MESSAGE": "La suppression de votre compte est irréversible. Saisissez le nom de votre compte ci-dessous pour confirmer que vous souhaitez le supprimer définitivement.",
        "BUTTON_TEXT": "Supprimer",
        "DISMISS": "Annuler",
        "PLACE_HOLDER": "Veuillez saisir {accountName} pour confirmer"
      },
      "SUCCESS": "Compte marqué pour suppression",
      "FAILURE": "Impossible de supprimer le compte, veuillez réessayer !",
      "SCHEDULED_DELETION": {
        "TITLE": "Compte programmé pour suppression",
        "MESSAGE_MANUAL": "Ce compte est programmé pour suppression le {deletionDate}. Cette demande a été faite par un administrateur. Vous pouvez annuler la suppression avant cette date.",
        "MESSAGE_INACTIVITY": "Ce compte est programmé pour suppression le {deletionDate} en raison de l'inactivité du compte. Vous pouvez annuler la suppression avant cette date.",
        "CLEAR_BUTTON": "Annuler la suppression programmée"
      }
    },
    "FORM": {
      "ERROR": "Veuillez corriger les erreurs du formulaire",
      "GENERAL_SECTION": {
        "TITLE": "Paramètres généraux",
        "NOTE": ""
      },
      "ACCOUNT_ID": {
        "TITLE": "ID de compte",
        "NOTE": "Cet identifiant est requis si vous construisez une intégration basée sur l'API"
      },
      "NAME": {
        "LABEL": "Nom du compte",
        "PLACEHOLDER": "Votre nom de compte",
        "ERROR": "Veuillez entrer un nom de compte valide"
      },
      "LANGUAGE": {
        "LABEL": "Langue du site",
        "PLACEHOLDER": "Votre nom de compte",
        "ERROR": ""
      },
      "DOMAIN": {
        "LABEL": "Domaine de courriel entrant",
        "PLACEHOLDER": "Le domaine où vous allez recevoir les courriels",
        "ERROR": ""
      },
      "SUPPORT_EMAIL": {
        "LABEL": "Courriel d'assistance",
        "PLACEHOLDER": "L'adresse de courriel de support de votre entreprise",
        "ERROR": ""
      },
      "AUTO_RESOLVE_DURATION": {
        "LABEL": "Nombre de jours après qu'un ticket soit automatiquement résolu s'il n'y a pas d'activité",
        "NOTE": "Nombre d'heures d'inactivité après lesquelles toute conversation ouverte sera résolue automatiquement.",
        "PLACEHOLDER": "30",
        "ERROR": "Veuillez entrer une durée de résolution automatique valide (minimum 1 jour et maximum 999 jours)"
      },
      "AUTO_RESOLVE_EMPTY_DURATION": {
        "LABEL": "Nombre de jours après lesquels une conversation vide doit être résolue automatiquement s'il n'y a aucune activité",
        "PLACEHOLDER": "jamais",
        "ERROR": "Veuillez entrer une durée valide pour la résolution automatique des conversations vides (minimum 1 jour et maximum 999 jours)"
      },
      "FEATURES": {
        "INBOUND_EMAIL_ENABLED": "La continuité des conversations avec les courriels est activée pour votre compte.",
        "CUSTOM_EMAIL_DOMAIN_ENABLED": "Vous pouvez maintenant recevoir des courriels dans votre domaine personnalisé."
      },
      "PHONE": {
        "TITLE": "Paramètres PBX",
        "NOTE": "Configurer la connexion à votre PBX pour les appels téléphoniques",
        "SIP_HOST": {
          "LABEL": "Domaine SIP"
        },
        "DIALING_MODE": {
          "LABEL": "Mode de numérotation",
          "MODES": {
            "direct": "Direct - l'appel est immédiatement composé en cliquant sur le lien téléphonique",
            "indirect": "Indirect - le numéro de téléphone est préparé dans la zone de saisie du widget téléphone"
          }
        },
        "CALL_RECORDING_ACCESS": {
          "LABEL": "Accès aux enregistrements d'appels",
          "MODES": {
            "admin_only": "Administrateurs uniquement",
            "admin_and_assigned_agent": "Administrateurs et agent assigné",
            "inbox_members": "Tous les agents ayant accès à la boîte de réception"
          }
        }
      },
      "EMAIL": {
        "TITLE": "Paramètres e-mail",
        "NOTE": "Modifie le comportement des boîtes de réception e-mail"
      },
      "CONVERSATION_TIMESTAMP_DISPLAY_MODE": {
        "LABEL": "Mode d'affichage de l'horodatage de la conversation",
        "MODES": {
          "both": "Création et dernière activité",
          "last_activity_only": "Dernière activité uniquement",
          "last_customer_message": "Dernier message du client"
        }
      },
      "BLOCK_DOMAINS_WITH_LOW_REPUTATION": {
        "LABEL": "Bloquer les domaines ayant une faible réputation"
      },
      "INCLUDE_PREVIOUS_EMAIL_MESSAGE": {
        "LABEL": "Inclure le message original dans la réponse à l'e-mail"
      },
      "RESOLVE_NEW_CONVERSATION": {
        "LABEL": "Résoudre automatiquement une nouvelle conversation"
      },
      "MOVE_CONVERSATIONS_BY_ORDERS": {
        "LABEL": "Déplacer automatiquement une nouvelle conversation e-mail vers la boîte de réception du robot qui a traité les commandes du contact"
      },
      "EXTENDED_LABELS": {
        "LABEL": "Étiquettes étendues - Autoriser des noms d'étiquettes plus longs avec une interface popup plus grande"
      },
      "ENABLE_LAST_AGENT": {
        "LABEL": "LastAgent - Attribuer automatiquement la conversation à l'agent qui a créé la dernière réponse"
      },
      "PUSH_NOTIFICATION_MODE": {
        "LABEL": "Mode de notification push",
        "MODES": {
          "all_inboxes": "Toutes les boîtes de réception - Envoyer des notifications pour tous les types de canaux",
          "chat_only": "Chat uniquement - Envoyer des notifications uniquement pour les canaux hors e-mail"
        }
      },
      "ALLOW_TOGGLE_SIGNATURE": {
        "LABEL": "Autoriser la bascule de la signature sur les messages envoyés"
      },
      "WALLBOARD_CHAT_STATUS_ENABLED": {
        "LABEL": "Afficher le statut du chat de l'agent sur le wallboard"
      },
      "SHOW_FULL_ATTACHMENT_NAMES": {
        "LABEL": "Afficher les noms complets des pièces jointes sans troncature"
      },
      "PASSWORD_LOGIN_MODE": {
        "LABEL": "Connexion par mot de passe",
        "MODES": {
          "allowed_for_all": "Autorisée pour tous les utilisateurs",
          "allowed_for_agents_only": "Autorisée pour les agents uniquement (les administrateurs doivent utiliser OAuth)",
          "password_login_disabled": "Désactivée - OAuth uniquement"
        }
      }
    },
    "NEW_VERSION_AVAILABLE": "Une nouvelle version est disponible. Rechargez pour obtenir les dernières mises à jour.",
    "RELOAD_NOW": "Mettre à jour maintenant",
    "LEARN_MORE": "En savoir plus",
    "PAYMENT_PENDING": "Votre paiement est en attente. Merci de mettre à jour vos informations de paiement pour continuer à utiliser ce logiciel",
    "LIMITS_UPGRADE": "Votre compte a dépassé les limites d'utilisation, veuillez mettre à niveau votre plan pour continuer à utiliser ce logiciel",
    "OPEN_BILLING": "Ouvrir la facturation"
  },
  "FORMS": {
    "MULTISELECT": {
      "ENTER_TO_SELECT": "Appuyer sur Entrée pour sélectionner",
      "ENTER_TO_REMOVE": "Appuyer sur Entrée pour supprimer",
      "NO_OPTIONS": "La liste est vide",
      "NO_RESULT": "Aucun résultat trouvé",
      "SELECT_ONE": "Sélectionnez un",
      "SELECT": "Sélectionner"
    }
  },
  "NOTIFICATIONS_PAGE": {
    "HEADER": "Notifications",
    "MARK_ALL_DONE": "Tout marquer comme terminé",
    "DELETE_TITLE": "Supprimé",
    "UNREAD_NOTIFICATION": {
      "TITLE": "Notifications non lues",
      "ALL_NOTIFICATIONS": "Visualiser toutes les notifications",
      "LOADING_UNREAD_MESSAGE": "Chargement des notifications non lues ...",
      "EMPTY_MESSAGE": "Vous n’avez pas de notifications non lues"
    },
    "LIST": {
      "404": "Aucune notification",
      "LOADING_MESSAGE": "Chargement des notifications...",
      "TABLE_HEADER": [
        "Nom",
        "Numéro de téléphone",
        "Conversations",
        "Dernièrement contacté"
      ]
    },
    "TYPE_LABEL": {
      "conversation_creation": "Nouvelle conversation",
      "conversation_assignment": "Conversation assignée",
      "assigned_conversation_new_message": "Nouveau message",
      "participating_conversation_new_message": "Nouveau message",
      "conversation_mention": "Mention",
      "sla_missed_first_response": "SLA Missed",
      "sla_missed_next_response": "SLA Missed",
      "sla_missed_resolution": "SLA Missed"
    }
  },
  "NETWORK": {
    "NOTIFICATION": {
      "OFFLINE": "Hors ligne",
      "RECONNECTING": "Reconnecting...",
      "RECONNECT_SUCCESS": "Reconnected"
    },
    "BUTTON": {
      "REFRESH": "Actualiser"
    },
    "CONNECTION_LOST": {
      "TITLE": "Connexion perdue",
      "DESCRIPTION": "Impossible de joindre le serveur. Vérifiez votre connexion et réessayez.",
      "RETRY": "Réessayer"
    }
  },
  "COMMAND_BAR": {
    "SEARCH_PLACEHOLDER": "Rechercher ou aller à",
    "SECTIONS": {
      "GENERAL": "Général",
      "REPORTS": "Rapports",
      "CONVERSATION": "Conversation",
      "BULK_ACTIONS": "Bulk Actions",
      "CHANGE_ASSIGNEE": "Changer de responsable",
      "CHANGE_PRIORITY": "Modifier la priorité",
      "CHANGE_TEAM": "Changer d’équipe",
      "SNOOZE_CONVERSATION": "Clôturer la conversation",
      "EXECUTE_MACRO": "Exécuter une macro",
      "ADD_LABEL": "Ajouter une étiquette à la conversation",
      "REMOVE_LABEL": "Supprimer l'étiquette de la conversation",
      "SETTINGS": "Paramètres",
      "AI_ASSIST": "Assistance IA",
      "APPEARANCE": "Apparence",
      "SNOOZE_NOTIFICATION": "Mettre la notification en veille"
    },
    "COMMANDS": {
      "GO_TO_CONVERSATION_DASHBOARD": "Aller au tableau de bord des conversations",
      "GO_TO_CONTACTS_DASHBOARD": "Aller au tableau de bord des contacts",
      "GO_TO_REPORTS_OVERVIEW": "Accéder à la vue d'ensemble des rapports",
      "GO_TO_CONVERSATION_REPORTS": "Accéder aux rapports de conversation",
      "GO_TO_AGENT_REPORTS": "Aller aux rapports d'agent",
      "GO_TO_LABEL_REPORTS": "Aller aux rapports d'étiquette",
      "GO_TO_INBOX_REPORTS": "Accéder aux rapports de la boîte de réception",
      "GO_TO_TEAM_REPORTS": "Aller dans les rapports de l'équipe",
      "GO_TO_SETTINGS_AGENTS": "Aller dans les paramètres de l'agent",
      "GO_TO_SETTINGS_TEAMS": "Aller dans les paramètres de l'équipe",
      "GO_TO_SETTINGS_INBOXES": "Accéder aux paramètres de la boîte de réception",
      "GO_TO_SETTINGS_LABELS": "Allez dans les paramètres d'étiquette",
      "GO_TO_SETTINGS_CANNED_RESPONSES": "Accéder aux paramètres de réponse préenregistrée",
      "GO_TO_SETTINGS_APPLICATIONS": "Accéder aux paramètres de l'application",
      "GO_TO_SETTINGS_ACCOUNT": "Accéder aux paramètres du compte",
      "GO_TO_SETTINGS_PROFILE": "Accéder aux paramètres du profil",
      "GO_TO_NOTIFICATIONS": "Accéder aux notifications",
      "ADD_LABELS_TO_CONVERSATION": "Ajouter une étiquette à la conversation",
      "ASSIGN_AN_AGENT": "Affecter un agent",
      "AI_ASSIST": "Assistance IA",
      "ASSIGN_PRIORITY": "Attribuer priorité",
      "ASSIGN_A_TEAM": "Assigner une équipe",
      "EXECUTE_A_MACRO": "Exécuter une macro",
      "MUTE_CONVERSATION": "Désactiver la conversation",
      "UNMUTE_CONVERSATION": "Rétablir la conversation",
      "REMOVE_LABEL_FROM_CONVERSATION": "Supprimer l'étiquette de la conversation",
      "REOPEN_CONVERSATION": "Reprendre la conversation",
      "RESOLVE_CONVERSATION": "Reprendre la conversation",
      "SEND_TRANSCRIPT": "Envoyer un résumé par email",
      "SNOOZE_CONVERSATION": "Clôturer la conversation",
      "UNTIL_NEXT_REPLY": "Jusqu’à la prochaine réponse",
      "UNTIL_NEXT_WEEK": "Jusqu'à la semaine prochaine",
      "UNTIL_TOMORROW": "Jusqu'à demain",
      "UNTIL_NEXT_MONTH": "Jusqu'au mois prochain",
      "AN_HOUR_FROM_NOW": "D'ici une heure",
      "UNTIL_CUSTOM_TIME": "Personnalisé...",
      "CHANGE_APPEARANCE": "Changer l'apparence",
      "LIGHT_MODE": "Clair",
      "DARK_MODE": "Sombre",
      "SYSTEM_MODE": "Système",
      "SNOOZE_NOTIFICATION": "Mettre la notification en veille"
    }
  },
  "DASHBOARD_APPS": {
    "LOADING_MESSAGE": "Chargement de l'application du tableau de bord ..."
  },
  "COMMON": {
    "OR": "Ou",
    "CLICK_HERE": "cliquez ici"
  }
}
